export const TRANSACTION_BASE_URL = "https://etherscan.io/tx/";
export const MINT_FEE = 0;
